<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                        <th>Bedrijf - afdeling</th>
                        <th>Aanplantdatum</th>
                        <th>Einddatum</th>
                        <th>Gewas</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="item in items">
                        <tr>
                            <td colspan="5"><i>{{item.bedrijf.naam}} - {{item.naam}}</i></td>
                        </tr>
                        <template v-for="teelt in item.teelt_n">
                            <tr>
                                <td></td>
                                <td>{{datumDDMMYYYY(teelt.aanplantdatum)}}</td>
                                <td>{{datumDDMMYYYY(teelt.einddatum)}}</td>
                                <td>{{teelt.teelt.naam}} - {{teelt.ras}}</td>
                                <td nowrap>
                                    <router-link :to="'/beheer/afdelingteelt/edit/' + teelt.id" title="Teelt wijzigen"><i class="fa fa-pencil-square-o"></i></router-link>
                                    &nbsp;
                                    <router-link :to="'/beheer/afdelingteelt/dliprofiel/' + teelt.id" title="DLI profiel"><i class="fa fa-thermometer-0" v-bind:class="{ 'transp': !teelt.profielbestaat }"></i></router-link>
                                    &nbsp;
                                    <router-link :to="'/beheer/afdelingteelt/klassiek/' + teelt.id" title="Klassiek belichtingsschema"><i class="fa fa-lightbulb-o" v-bind:class="{ 'transp': !teelt.schemabestaat }"></i></router-link>
                                    &nbsp;
                                    <router-link :to="'/beheer/afdelingteelt/lichtintegratie/' + teelt.id" title="Lichtintegratie"><i class="fa fa-sun-o" v-bind:class="{ 'transp': !teelt.schemabestaat }"></i></router-link>
                                    &nbsp;
                                    <router-link :to="'/beheer/afdelingteelt/samenvatting/' + teelt.id" title="Samenvatting"><i class="fa fa-line-chart" v-bind:class="{ 'transp': !teelt.schemabestaat }"></i></router-link>
                                    &nbsp;
                                    <router-link :to="'/beheer/afdelingteelt/werkelijk/' + teelt.id" title="Werkelijke belichting"><i class="fa fa-clock-o" v-bind:class="{ 'transp': !teelt.schemabestaat }"></i></router-link>
                                    &nbsp;
                                    <a title="Teelt verwijderen" href="javascript:void(0)" @click="bevestigItem(teelt.id, teelt.teelt.naam + ' - ' + teelt.ras)" v-show="teelt.deleteok"><i class="fa fa-trash"></i></a>

                                    <span v-show="(! teelt.deleteok) && (user.m >= 7)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                    <a v-show="(! teelt.deleteok) && (user.m >= 7)" title="Teelt verwijderen (incl. belichting)" href="javascript:void(0)" @click="bevestigItem2(teelt.id, teelt.teelt.naam + ' - ' + teelt.ras)"><i class="fa fa-bell-slash-o"></i></a>

                                </td>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </table>
                <nav>
                    <ul class="pagination">
                        <li class="page-item"><router-link class="page-link" to="/beheer/afdelingteelt/new">Teelt toevoegen</router-link></li>
                    </ul>
                </nav>
            </div><!--/.col-->
        </div><!--/.row-->

        <b-modal title="Verwijderen" size="sm" v-model="warningModal" @ok="deleteItem">
            Teelt <b>{{name}}</b> wordt verwijderd. Bent u zeker?
        </b-modal>

        <b-modal title="Verwijderen" size="sm" v-model="warningModal2" @ok="deleteItem2">
            Teelt <b>{{name}}</b> (incl. belichtingsgegevens) wordt verwijderd. Bent u zeker?
        </b-modal>
    </div>
</template>

<script>
    import datefunctions from '../../helpers/datefunctions';

    export default {
        name: 'List',
        props: ['items'],
        data () {
            return {
                id: -1,
                name: '',
                warningModal: false,
                warningModal2: false,
            };
        },
        computed: {
            user () {
                return this.$store.getters.user;
            },
        },
        methods: {
            bevestigItem (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal = true;
            },
            deleteItem () {
                this.warningModal = false;
                this.$emit('delete-item', this.id);
            },
            bevestigItem2 (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal2 = true;
            },
            deleteItem2 () {
                this.warningModal2 = false;
                this.$emit('destroy-item', this.id);
            },
            datumDDMMYYYY (datum) {
                return datefunctions.datetoDDMMYYYY(datum);
            },
        },
    };
</script>

<style>

.transp {
    text-decoration: line-through;
    color: rgba(50, 80, 109, 0.55);
}

</style>



// WEBPACK FOOTER //
// src/pages/afdelingteelt/List.vue